import React, { Component, useEffect, useLayoutEffect, useState } from 'react';
import { Grid, Tabs, CircularProgress,Drawer } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import classNames from 'classnames';
import t from '../../utils/translateUtil';
import Typography from '../../components/CustomTypo'
import Typo from '../../components/CustomTypo';
import { LinkRouter } from '../../components/Link';
import ButtonCustom from '../../components/ButtonCustom';
import { PlaceIcon, HomeIcon, ReceiptBlackIcon, CalanderTodayBlackIcon } from '../../components/icons';
import CustomizedCircularProgress from '../../components/CircularProgress';

const styles = theme => ({
    drawerPaper: {
        width: '30%',
        height:'100%',
        backgroundColor: theme.palette.background.secondary,
        [theme.breakpoints.down('xs')]: {
            width: '80%',
        },
    },
    container:{
        padding: theme.spacing(6,2,2,2),
    },
    filter_content: {
        paddingTop: theme.spacing(2),
        alignItems: 'center',
    },
    icon: {
        border: '1px solid ' + theme.palette.border.secondary,
        justifyCenter: 'center',
        alignItems: 'center',
        display: 'flex',
        borderRadius: theme.spacing(2),
        marginRight: theme.spacing(2),
        "& img": {
            padding: theme.spacing(1),
        }
    }
});

function FilterView(props){
    const [windowWidth, setWindowWidth] = useState(undefined);

    useEffect(()=>{
        window.addEventListener('resize', handleResize());
    },[]);

    const handleResize = () => {
        setWindowWidth(window.innerWidth);
    }
    const { filter_options, classes, t, onClose, showLoading, onSelectFilter, filterSelected } = props;
    return (
        <Drawer
            variant="temporary"
            anchor={'right'}
            open={props.open}
            onClose={()=>onClose()}
            classes={{
                paper: classes.drawerPaper
            }}
            ModalProps={{
                keepMounted: true, // Better open performance on mobile.
            }}>
                <Grid xs={12} item className={classes.container}>
                    <Grid xs={12} item>
                        <Typography variant='caption1'>{t('filter')}</Typography>
                    </Grid>
                    {showLoading&&<Grid xs={12} item container justify='center'>
                        <CustomizedCircularProgress/>
                    </Grid>}
                    <Grid item xs={12} container>
                        <ButtonCustom color={filterSelected == 1?'success':'primary'} 
                            onClick={() => onSelectFilter(1)} size='xs'>
                            {t('Monthly')}
                        </ButtonCustom>
                        <ButtonCustom color={filterSelected == 3?'success':'light'} 
                            onClick={() => onSelectFilter(3)} size='xs'>
                            {t('3 Months')}
                        </ButtonCustom>
                        <ButtonCustom color={filterSelected == 6?'success':'light'} 
                            onClick={() => onSelectFilter(6)} size='xs'>
                            {t('6 Months')}
                        </ButtonCustom>
                    </Grid>
                    <Grid item container>
                        <Grid item xs={6} container className={classes.filter_content}>
                            <Grid item>
                                <Grid item className={classes.icon}>
                                    <ReceiptBlackIcon />
                                </Grid>
                            </Grid>
                            <Grid item>
                                <Typo variant="subtitle2">{t('7th of month')}</Typo>
                                <Typo variant="caption">{t('Billing Day')}</Typo>
                            </Grid>
                        </Grid>
                        <Grid item xs={6} container className={classes.filter_content}>
                            <Grid item>
                                <Grid item className={classes.icon}>
                                    <CalanderTodayBlackIcon />
                                </Grid>
                            </Grid>
                            <Grid item>
                                <Typo variant="subtitle2">{t('07 Oct 2021')}</Typo>
                                <Typo variant="caption">{t('Next Billing Date')}</Typo>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                
        </Drawer>
    );
}

export default withStyles(styles)(withTranslation()(FilterView));